import { sortBy } from "lodash";
import { mergeArraysOfObjectsByProp } from "~/helpers";

export const createReorderingUpdates = <T extends { id: number; order: number }>(
  sortedItems: T[],
  activeId: number | null,
  overId: number | null
): {
  updates: T[];
  updateIds: number[];
} => {
  // Handle null or undefined parameters
  if (!activeId || !overId || !sortedItems || sortedItems.length === 0) {
    return { updates: [], updateIds: [] };
  }

  // this is used for all sortable, they don't all have text, i've fixed the type in the component
  const sortedItemsCopy = sortBy(
    sortedItems.map((item) => ({ ...item })),
    "order"
  );

  const activeIndex = sortedItemsCopy.findIndex((d) => d.id === activeId);
  const activeItem = sortedItemsCopy[activeIndex];
  const overIndex = sortedItemsCopy.findIndex((d) => d.id === overId);
  const updates: T[] = [];

  // Drag Down
  if (activeIndex < overIndex) {
    sortedItemsCopy.forEach((item, index) => {
      if (index <= overIndex && index !== activeIndex) {
        updates.push({ ...item, order: index - 1 });
      }
    });
    updates.push({ ...activeItem, order: overIndex });
  }
  // Drag Up
  else if (activeIndex > overIndex) {
    sortedItemsCopy.forEach((item, index) => {
      if (index >= overIndex && index !== activeIndex) {
        updates.push({ ...item, order: index + 1 });
      }
    });
    updates.push({ ...activeItem, order: overIndex });
  }
  const sortedUpdated = sortBy(mergeArraysOfObjectsByProp(updates, sortedItemsCopy, "id"), "order");

  // Sort the updates by order
  return {
    updates: sortedUpdated,
    updateIds: updates.map((u) => u.id),
  };
};
